import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-naming-guidelines',
  standalone: true,
  imports: [MatDialogModule, FormsModule],
  templateUrl: './naming-guidelines.component.html',
  styleUrls: ['./naming-guidelines.component.css'],
})
export class NamingGuidelinesComponent {
  constructor(public dialogRef: MatDialogRef<NamingGuidelinesComponent>) {}

  ok(): void {
    this.dialogRef.close();
  }
}
